<script>
    import { finalInspectionStore } from "./store.js";
    import { slide } from "svelte/transition";

    export let getData;
</script>

<div class="search-area">
    {#if $finalInspectionStore.search.isExpanded}
        <section
            class="search-panel"
            transition:slide|local={{ duration: 300 }}
        >
            <div class="search-grid">
                <div class="field">
                    <label>생산계획번호</label>
                    <input
                        type="text"
                        placeholder="계획번호 입력"
                        bind:value={$finalInspectionStore.search.prdctn_plan_no}
                        autocomplete="off"
                    />
                </div>
                <div class="field">
                    <label>LOT NO</label>
                    <input
                        type="text"
                        placeholder="LOT 번호 입력"
                        bind:value={$finalInspectionStore.search.lot_no}
                        autocomplete="off"
                    />
                </div>
                <div class="field">
                    <label>규격번호</label>
                    <input
                        type="text"
                        placeholder="규격번호 입력"
                        bind:value={$finalInspectionStore.search.stndrd_no}
                        autocomplete="off"
                    />
                </div>
                <div class="field">
                    <label>모델명</label>
                    <input
                        type="text"
                        placeholder="모델명 입력"
                        bind:value={$finalInspectionStore.search.modl_no}
                        autocomplete="off"
                    />
                </div>
                <div class="field">
                    <label>차대번호(제조번호)</label>
                    <input
                        type="text"
                        placeholder="차대번호 입력"
                        bind:value={$finalInspectionStore.search.mnfctur_no}
                        autocomplete="off"
                    />
                </div>
                <div class="field">
                    <label>검사일</label>
                    <div class="date-range-inputs">
                        <input
                            type="date"
                            bind:value={$finalInspectionStore.search.startDate}
                            autocomplete="off"
                        />
                        <span>~</span>
                        <input
                            type="date"
                            bind:value={$finalInspectionStore.search.endDate}
                            autocomplete="off"
                        />
                    </div>
                </div>
                <div class="field">
                    <label>검사자사번</label>
                    <input
                        type="text"
                        placeholder="사번 입력"
                        bind:value={$finalInspectionStore.search.inspct_empno}
                        autocomplete="off"
                    />
                </div>
                <div class="field">
                    <label>검사원명</label>
                    <input
                        type="text"
                        placeholder="이름 입력"
                        bind:value={
                            $finalInspectionStore.search.search_korean_nm
                        }
                        autocomplete="off"
                    />
                </div>
                <div class="field">
                    <label>판정</label>
                    <select bind:value={$finalInspectionStore.search.prpert_at}>
                        <option value="전체">전체</option>
                        <option value="Y">적합</option>
                        <option value="N">부적합</option>
                    </select>
                </div>
            </div>
            <button class="main-btn" on:click={getData}>데이터 조회하기</button>
        </section>
    {/if}
    <div
        class="toggle-bar"
        on:click={() =>
            finalInspectionStore.update((s) => ({
                ...s,
                search: {
                    ...s.search,
                    isExpanded: !s.search.isExpanded,
                },
            }))}
    >
        <div class="toggle-content">
            <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
            >
                <path
                    d={$finalInspectionStore.search.isExpanded
                        ? "m18 15-6-6-6 6"
                        : "m6 9 6 6 6-6"}
                />
            </svg>
            <span>
                {$finalInspectionStore.search.isExpanded
                    ? "조회 조건 접기"
                    : "조회 조건 펼쳐서 다시 검색하기"}
            </span>
        </div>
    </div>
</div>

<style>
    .search-area {
        flex-shrink: 0;
        background: white;
        border-bottom: 1px solid #e2e8f0;
    }
    .search-panel {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 15px 15px 10px 15px;
        overflow: hidden;
    }
    .search-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
    }
    .field label {
        display: block;
        font-size: 0.7rem;
        font-weight: 800;
        color: #64748b;
        margin-bottom: 6px;
    }
    .field input,
    .field select {
        width: 100%;
        height: 35px;
        border: 1.5px solid #e2e8f0;
        border-radius: 4px;
        padding: 0 8px;
        font-size: 0.85rem;
        box-sizing: border-box;
    }
    .field input:focus,
    .field select:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
    .date-range-inputs {
        display: flex;
        align-items: center;
        gap: 2px;
    }
    .date-range-inputs input {
        flex: 1;
        min-width: 0;
        padding: 0 4px;
        font-size: 0.75rem;
    }
    .date-range-inputs span {
        font-size: 0.7rem;
        color: #94a3b8;
    }
    .main-btn {
        width: 100%;
        height: 40px;
        background: #3b82f6;
        color: white;
        border: none;
        border-radius: 4px;
        font-weight: 800;
        margin-top: 10px;
        cursor: pointer;
        transition: 0.2s;
    }
    .main-btn:hover {
        background: #2563eb;
    }
    .toggle-bar {
        padding: 8px 0;
        background: #ffffff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        border-top: 1px solid #f1f5f9;
    }
    .toggle-content {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #3b82f6;
        font-size: 0.85rem;
        font-weight: 800;
    }
    @media (max-width: 768px) {
        .search-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }
</style>
